import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import FormField from './FormField.js';
const FinalFormFormField = ({ meta, children, ...restProps }) => {
    const { touched, error, submitError } = meta;
    return (_jsx(FormField, { ...restProps, error: error, submitError: submitError, touched: touched, children: children }));
};
export default React.memo(FinalFormFormField);
